<template>
  <div class="search-wrapper">

    <i class="fas fa-search ml-3"></i>

    <input type="text"
           class="search-input ml-3 openedInput"
           placeholder="Search..."
           v-model="textToSearch">

    <i v-if="textToSearch"
       class="fas fa-times ml-3"
       @click="searchCleared"></i>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        textToSearch: null
      }
    },

    created() {
      this.$root.$on('agenda-loaded', this.onAgendaLoaded)
    },

    methods: {
      onAgendaLoaded() {
        if (this.textToSearch) {
          this.$root.$emit('search.searching', this.textToSearch)
        }
      },

      searchCleared() {
        this.textToSearch = null
        this.$root.$emit('search.clear', {})
      }
    },

    watch: {
      textToSearch: function (search) {
        this.$root.$emit('search.searching', search)
      }
    }
  }
</script>

<style scoped>
  .search-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .search-input {
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #716aca;
    -webkit-transition: all .3s ease;
    -moz-transition: all .3s ease;
    transition: all .3s ease;
    width: 0;
  }

  .search-input:focus,
  .search-input:hover {
    border-bottom: 1px solid #615EBB;
    transform: scale(1.05);
    outline: none;
  }

  .openedInput {
    width: 250px;
  }

  .fa-search {
    font-size: 1.5rem;
    color: #716aca;
    margin-right: auto
  }

  .fa-times {
    color: #b8bece;
  }

  .fas {
    cursor: pointer;
  }

  .fas:hover {
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/LeftMenu/Search.vue